import {EventEmitter, Injectable, Output} from "@angular/core";


@Injectable({
  providedIn: "root",
})
export class SharedService {
  @Output() aClickedEvent = new EventEmitter();
  @Output() updateActivities = new EventEmitter();
  @Output() updatedBadgeTotal  = new EventEmitter();

  AClicked() {
    this.aClickedEvent.emit();
  }

  updateActivityList() {
    this.updateActivities.emit()
  }

  needToUpdate() {
    this.updatedBadgeTotal.emit();
  }

}
